export const flowersDeliveryLocation = [
  { name: 'Funeral home', value: 'FUNERAL_HOME' },
  { name: 'Head office', value: 'HEAD_OFFICE' },
  { name: 'Service venue', value: 'SERVICE_VENUE' },
  { name: 'Client home', value: 'CLIENTS_HOME' },
  { name: 'Travel with family', value: 'TRAVEL_WITH_FAMILY' },
  { name: 'Other', value: 'OTHER' },
];
